'use es6';
/**
 * Instances are intended to be nodes in a singly linked list.
 */

export default class LinkedListNode {
  constructor(params) {
    const {
      next = null,
      data = null
    } = params || {};
    this.next = next;
    this.data = data;
  }

}